export const getMediaUrl = (partialPath: string) => {
  const baseUrl = 'https://public.bumpy.dating/web/';
  return `${baseUrl}${partialPath}`;
};
